const messages: Record<string, string> = {
  invalid_credentials: "That email and password do not match.",
  too_many_attempts: "Too many attempts. Wait ten minutes and try again.",
  weak_password: "Use at least 6 characters for each password.",
  invalid_email: "Enter a valid email address.",
  invalid_wearer_email: "Enter a valid email address for the wearer account.",
  invalid_controller_email: "Enter a valid email address for the controller account.",
  invalid_display_name: "Enter a name between 1 and 40 characters.",
  emails_must_differ: "The two accounts need different email addresses.",
  setup_complete: "This server has already been set up.",
  setup_access_required: "Open the private setup link created for this server.",
  invalid_recovery_code: "That recovery code is not valid.",
  session_not_armed: "The wearer has not armed this session.",
  wearer_not_present: "The wearer must be present.",
  device_output_not_ready: "The wearer bridge is not ready for output.",
  safety_checklist_required: "Confirm every safety check before arming.",
  intensity_outside_wearer_limit: "That intensity is outside the wearer’s limit.",
  hold_already_active: "A hold is already active.",
  hold_not_active: "The hold is no longer active.",
  origin_not_allowed: "This browser origin is not allowed by the server."
};

export function readableError(error: unknown) {
  const code = error instanceof Error ? error.message : String(error);
  return messages[code] ?? "Something went wrong. Please try again.";
}
